function slugifyArticleShareTitle(title) {
  return (title || 'article-image')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

function openArticleShareWindow(shareUrl) {
  window.open(shareUrl, 'articleShareWindow', 'width=600,height=600,noopener,noreferrer');
}

function copyArticleShareLink(url, button) {
  var label = button.querySelector('.__article_share_action_label');
  var originalText = label ? label.textContent : '';

  function showCopiedState() {
    if (!label) return;
    label.textContent = 'Copied';
    button.classList.add('__article_share_action_copied');
    window.setTimeout(function () {
      label.textContent = originalText;
      button.classList.remove('__article_share_action_copied');
    }, 1800);
  }

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(url).then(showCopiedState);
    return;
  }

  var input = document.createElement('input');
  input.value = url;
  input.setAttribute('readonly', '');
  input.style.position = 'absolute';
  input.style.left = '-9999px';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
  showCopiedState();
}

function downloadArticleShareImage(imageUrl, title) {
  if (!imageUrl) return;

  fetch(imageUrl, { mode: 'cors' })
    .then(function (response) {
      return response.blob();
    })
    .then(function (blob) {
      var objectUrl = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = objectUrl;
      link.download = slugifyArticleShareTitle(title) + '.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    })
    .catch(function () {
      window.open(imageUrl, '_blank', 'noopener,noreferrer');
    });
}

function shareArticleByEmail(url, title) {
  window.location.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
}

function shareArticleToInstagram(url, title, button) {
  copyArticleShareLink(url, button);
  window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
}

function handleArticleShareAction(button, actionsWrap) {
  var action = button.getAttribute('data-article-share-action');
  var url = actionsWrap.getAttribute('data-article-share-url');
  var title = actionsWrap.getAttribute('data-article-share-title');
  var image = actionsWrap.getAttribute('data-article-share-image');

  if (action === 'copy') {
    copyArticleShareLink(url, button);
  } else if (action === 'facebook') {
    openArticleShareWindow('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url));
  }  else if (action === 'x') {
    openArticleShareWindow('https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url));
  } else if (action === 'reddit') {
    openArticleShareWindow('https://www.reddit.com/submit?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title));
  } else if (action === 'linkedin') {
    openArticleShareWindow('https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url));
  } else if (action === 'email') {
    shareArticleByEmail(url, title);
  } else if (action === 'download') {
    downloadArticleShareImage(image, title);
  }
}

function bindArticleSharePopup(trigger, popup) {
  if (popup.dataset.articleShareBound === 'true') return;
  popup.dataset.articleShareBound = 'true';
  document.body.appendChild(popup);

  var closers = popup.querySelectorAll('[data-article-share-close]');
  var actionsWrap = popup.querySelector('.__article_share_popup_actions');
  var lastFocusedElement = null;

  function handleKeydown(event) {
    if (event.key === 'Escape') closePopup();
  }

  function openPopup() {
    lastFocusedElement = document.activeElement;
    popup.hidden = false;
    void popup.offsetHeight;
    requestAnimationFrame(function () {
      popup.classList.add('__article_share_popup_visible');
    });
    document.addEventListener('keydown', handleKeydown);
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.classList.remove('__article_share_popup_visible');
    document.removeEventListener('keydown', handleKeydown);
    document.body.style.overflow = '';
    window.setTimeout(function () {
      popup.hidden = true;
      if (lastFocusedElement) lastFocusedElement.focus();
    }, 450);
  }

  trigger.addEventListener('click', openPopup);

  closers.forEach(function (closer) {
    closer.addEventListener('click', closePopup);
  });

  if (actionsWrap) {
    actionsWrap.addEventListener('click', function (event) {
      var button = event.target.closest('[data-article-share-action]');
      if (!button) return;
      handleArticleShareAction(button, actionsWrap);
    });
  }
}

function initArticleSharePopups() {
  var triggers = document.querySelectorAll('[data-article-share-trigger]');
  triggers.forEach(function (trigger) {
    var targetId = trigger.getAttribute('aria-controls');
    var popup = document.getElementById(targetId);
    if (!popup) return;
    bindArticleSharePopup(trigger, popup);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArticleSharePopups);
} else {
  initArticleSharePopups();
}